module.exports = __webpack_public_path__ + "static/img/irole.8d4311d.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/tsz/irole.png
// module id = I17t
// module chunks = 7